// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=============={ Estilos para Formularios Base }=======================*/

/* Contenedor general para alinear CatalogoP y FormABC */
.form-container {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 20px;
  width: 100%;
}

/* Formulario completo */
.FormABC {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 2px solid #512DA8;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Asegurar que el contenido del formulario esté bien espaciado */
.FormABC-content {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1rem;
}

/* Encabezado del ABC */
.FormABC-header {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  background-color: #1976D2;
  color: #fff;
  border-bottom: 2px solid rgba(0, 0, 0, 0.125);
  font-size: 18px;
  font-weight: bold;
  padding: 0 15px;
}

/* Toolbar del ABC */
.FormABC-header-btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: rgba(116, 116, 116, 0.822);
  border-top: 2px solid #512DA8;
  border-bottom: 2px solid #512DA8;
}

.left-buttons, .right-buttons {
  display: flex;
  gap: 10px;
}

/* Pie del ABC */
.FormABC-footer {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  background-color: #BDBDBD;
  color: #fff;
  border-top: 2px solid #512DA8;
  padding: 5px;
  text-align: center;
}

/* Estilos para las filas del formulario */
.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

/* Estilos para los grupos de campos */
.form-group {
  flex: 1 1;
}

/* Estilos para campos de ancho completo */
.full-width {
  flex: 1 1 100%;
}

/* Estilos para las etiquetas */
.FormABC label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
  font-size: 0.9rem;
}

/* Estilos para uniformar inputs y dropdowns (TAMAÑO REDUCIDO) */
.FormABC input, 
.FormABC .p-dropdown,
.FormABC .p-inputtext,
.FormABC .p-dropdown-panel .p-dropdown-items {
  width: 100%;
  height: 30px;
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  line-height: 1.4;
  border-radius: 3px;
  box-sizing: border-box;
}

/* Ajustes específicos para los dropdowns */
.FormABC .p-dropdown {
  display: flex;
  align-items: center;
}

.FormABC .p-dropdown-label {
  padding: 0.25rem 0.5rem;
  margin: 0;
}

/* Corrección de la clase p-inputtext-sm */
.p-inputtext-sm .p-inputtext,
.p-inputtext.p-inputtext-sm {
  font-size: 0.875rem;
  height: 30px;
  padding: 0.25rem 0.5rem;
}

/* Garantizar consistencia en todos los elementos de formulario */
button, input, optgroup, select, textarea {
  margin: 0;
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.4;
  padding: 0.25rem 0.5rem;
}

/* Asegurar que el contenido del dropdown tenga el mismo estilo */
.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

/* Ajustar el icono del dropdown para que se alinee con el tamaño reducido */
.FormABC .p-dropdown .p-dropdown-trigger {
  width: 2rem;
  padding: 0 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/Css/catalogobase/catalogobase.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE,wDAAwD;AACxD;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,iEAAiE;AACjE;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,6CAA6C;EAC7C,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,SAAO;AACT;;AAEA,0CAA0C;AAC1C;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,gEAAgE;AAChE;;;;EAIE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA,0CAA0C;AAC1C;;EAEE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,iEAAiE;AACjE;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iEAAiE;AACjE;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["/*=============={ Estilos para Formularios Base }=======================*/\r\n\r\n/* Contenedor general para alinear CatalogoP y FormABC */\r\n.form-container {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 20px;\r\n  padding: 20px;\r\n  width: 100%;\r\n}\r\n\r\n/* Formulario completo */\r\n.FormABC {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  background-color: #fff;\r\n  background-clip: border-box;\r\n  border: 2px solid #512DA8;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Asegurar que el contenido del formulario esté bien espaciado */\r\n.FormABC-content {\r\n  flex: 1 1 auto;\r\n  min-height: 1px;\r\n  padding: 1rem;\r\n}\r\n\r\n/* Encabezado del ABC */\r\n.FormABC-header {\r\n  width: 100%;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: #1976D2;\r\n  color: #fff;\r\n  border-bottom: 2px solid rgba(0, 0, 0, 0.125);\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  padding: 0 15px;\r\n}\r\n\r\n/* Toolbar del ABC */\r\n.FormABC-header-btns {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px;\r\n  background-color: rgba(116, 116, 116, 0.822);\r\n  border-top: 2px solid #512DA8;\r\n  border-bottom: 2px solid #512DA8;\r\n}\r\n\r\n.left-buttons, .right-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n/* Pie del ABC */\r\n.FormABC-footer {\r\n  width: 100%;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: #BDBDBD;\r\n  color: #fff;\r\n  border-top: 2px solid #512DA8;\r\n  padding: 5px;\r\n  text-align: center;\r\n}\r\n\r\n/* Estilos para las filas del formulario */\r\n.form-row {\r\n  display: flex;\r\n  gap: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n/* Estilos para los grupos de campos */\r\n.form-group {\r\n  flex: 1;\r\n}\r\n\r\n/* Estilos para campos de ancho completo */\r\n.full-width {\r\n  flex: 1 1 100%;\r\n}\r\n\r\n/* Estilos para las etiquetas */\r\n.FormABC label {\r\n  font-weight: bold;\r\n  margin-bottom: 5px;\r\n  display: block;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Estilos para uniformar inputs y dropdowns (TAMAÑO REDUCIDO) */\r\n.FormABC input, \r\n.FormABC .p-dropdown,\r\n.FormABC .p-inputtext,\r\n.FormABC .p-dropdown-panel .p-dropdown-items {\r\n  width: 100%;\r\n  height: 30px;\r\n  font-size: 0.875rem;\r\n  padding: 0.25rem 0.5rem;\r\n  line-height: 1.4;\r\n  border-radius: 3px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Ajustes específicos para los dropdowns */\r\n.FormABC .p-dropdown {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.FormABC .p-dropdown-label {\r\n  padding: 0.25rem 0.5rem;\r\n  margin: 0;\r\n}\r\n\r\n/* Corrección de la clase p-inputtext-sm */\r\n.p-inputtext-sm .p-inputtext,\r\n.p-inputtext.p-inputtext-sm {\r\n  font-size: 0.875rem;\r\n  height: 30px;\r\n  padding: 0.25rem 0.5rem;\r\n}\r\n\r\n/* Garantizar consistencia en todos los elementos de formulario */\r\nbutton, input, optgroup, select, textarea {\r\n  margin: 0;\r\n  font-family: inherit;\r\n  font-size: 0.875rem;\r\n  line-height: 1.4;\r\n  padding: 0.25rem 0.5rem;\r\n}\r\n\r\n/* Asegurar que el contenido del dropdown tenga el mismo estilo */\r\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* Ajustar el icono del dropdown para que se alinee con el tamaño reducido */\r\n.FormABC .p-dropdown .p-dropdown-trigger {\r\n  width: 2rem;\r\n  padding: 0 0.25rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
